module.exports = __webpack_public_path__ + "img/content-new-1.b4e4f45.png";